import { asyncEpicStandard } from 'src/logic/helpers/epics/async.epic-helper';
import * as actions from './endorsement.actions';

export const endorsementAllAsyncEpic = asyncEpicStandard(actions.endorsementAllAsync, services =>
    services.api.endorsements.all()
);
